import { makeStyles, useTheme } from "@material-ui/core";

export const useElectronicIdStyles = () => {
  const { palette, customBorderRadius, typography } = useTheme();

  const useStyles = makeStyles({
    root: {
      "& #video .eid-ui-canvas": {
        fontSize: "0.875rem",
      },
      "& #video .eid-ui-canvas path": {
        stroke: palette.secondary.main,
        strokeWidth: 2,
      },
      "& #video .eid-button": {
        borderRadius: `${customBorderRadius.button}px`,
        boxSizing: "border-box",
        cursor: "pointer",
        display: "inline-block",
        fontStyle: "normal",
        fontSize: "1.25em",
        fontWeight: 600,
        lineHeight: "1.25em",
        padding: "0.625em 2em",
        textAlign: "center",
      },
      "& #video .eid-h1": {
        color: palette.text.title,
        fontFamily: typography.fontFamily,
        fontStyle: "normal",

        fontWeight: 700,
        fontSize: "1.25em",
        lineHeight: "1.5em",
        margin: 0,
        paddingBottom: "0.9em",
      },
      "& #video .eid-h2": {
        color: palette.text.primary,
        fontStyle: "normal",
        fontFamily: typography.fontFamily,
        fontWeight: 700,
        fontSize: " 1.25em",
        lineHeight: "1.5em",
        margin: 0,
        paddingBottom: "0.3em",
        paddingTop: "0.3em",
      },
      "& #video .eid-h3": {
        color: palette.text.title,
        fontStyle: "normal",
        fontFamily: typography.fontFamily,
        fontWeight: 700,
        fontSize: " 1.1em",
        lineHeight: "1.5em",
        margin: 0,
        paddingBottom: "0.3em",
        paddingTop: "0.3em",
      },
      "& #video .eid-h4": {
        color: palette.text.primary,
        fontStyle: "normal",
        fontFamily: typography.fontFamily,
        fontWeight: 700,
        fontSize: " 1.1em",
        lineHeight: "1.5em",
        margin: 0,
        paddingBottom: "0.3em",
        paddingTop: "0.3em",
      },
      "& #video .eid-h5": {
        color: palette.text.primary,
        fontStyle: "normal",
        fontFamily: typography.fontFamily,
        fontWeight: 700,
        fontSize: " 1.05em",
        lineHeight: "1.3em",
        margin: 0,
        paddingBottom: "0.3em",
        paddingTop: "0.3em",
      },
      "& #video .eid-portrait .eid-button": {
        width: "100%",
        maxWidth: "320px",
        paddingLeft: 0,
        paddingRight: 0,
      },
      "& #video .eid-button-disable": {
        backgroundColor: palette.action.disabledBackground,
        color: palette.action.disabled,
        cursor: "default",
      },
      "& #video .eid-button-primary": {
        backgroundColor: palette.primary.main,
        border: `2px solid ${palette.primary.main}`,
        color: palette.primary.contrastText,
      },
      "& #video .eid-button-primary:hover": {
        backgroundColor: palette.primary.dark,
        borderColor: palette.primary.dark,
      },
      "& #video .eid-button-primary:active": {
        backgroundColor: palette.primary.main,
        borderColor: palette.primary.main,
      },
      "& #video .eid-button-secondary": {
        border: `2px solid ${palette.grey[200]}`,
        color: palette.grey[200].dark,
        marginTop: "2.25em",
      },
      "& #video .eid-loading div": {
        borderColor: `${palette.primary.main}`,
      },
      "& #video img": {
        filter: "grayscale(1)",
      },
      "& #video .eid-call-to-action-2": {
        color: palette.text.primary,
        fontFamily: typography.fontFamily,
      },
      "& #video .eid-description": {
        color: palette.text.primary,
        fontFamily: typography.fontFamily,
      },

      "& #video .eid-equal-container": {
        textAlign: "center",
      },
      "& #video .eid-requirements": { marginTop: "8px" },
    },
  });

  const classes = useStyles();

  return { classes };
};
